
export function UseCases() {
  const useCases = [
    {
      icon: 'ri-building-line',
      title: 'For cities & beyond',
      description: 'The compact design combined with VTOL capabilities makes our aircraft perfect for flying in cities and terrains inaccessible by other modes of transport.'
    },
    {
      icon: 'ri-apps-line',
      title: 'For various use cases',
      description: 'We offer solutions that are highly adaptable to various scenarios. For instance, our DJT City can serve as an air aircraft or an emergency rescue vehicle.'
    },
    {
      icon: 'ri-time-line',
      title: 'For a simplified life',
      description: 'Our game-changing eVTOLs are tailored to bypass congested roads, providing quick connections for people in urban and suburban areas.'
    }
  ];

  return (
    <section id="solutions" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {useCases.map((useCase, index) => (
            <div key={index} className="text-center">
              <div className="w-20 h-20 bg-gray-900 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className={`${useCase.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">
                {useCase.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {useCase.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
